import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd";
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import { useFormattedVisaOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import { is } from "date-fns/locale";
import ImageCropper from "Components/UI/Image/ImageCropper";
const activestatus = [
  { id: true, label: "Yes", value: true },
  { id: false, label: "No", value: false },
];

const VisaDetails = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "otherVisaDetails",
  });

  const visaDetails = watch("otherVisaDetails") || [];

  const visaTypeOptions = useFormattedVisaOption(watch("companyCode"));

  const addVisaDetailsRow = () => {
    const newExperience = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      visaNumber: "",
      typeofVisa: "",
      duration: "",
      issuesDate: "",
      expiryDate: "",
      issuedBy: "",
      sposorship: "",
      busniessVisa: "",
      country: "",
      agentName: "",
      agentPhone: "",
      agentEmail: "",
      frontImage: "",
      backImage: "",
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("otherVisaDetails", [...visaDetails, newExperience]);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addVisaDetailsRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Visa Number</th>
              <th>Type Of Visa</th>
              <th>Duration</th>
              <th>Issue Date</th>
              <th>Expiry Date</th>
              <th>Issued By</th>
              <th>sposorship</th>
              <th>Busniess Visa</th>
              <th>Country</th>
              <th>Agent Name</th>
              <th>Agent Phone</th>
              <th>Agent Email</th>
              <th>Front Image</th>
              <th>Back Image</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {visaDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].visaNumber`}
                      type="text"
                      placeholder="Visa Number"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.visaNumber
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].typeofVisa`}
                      type="commonSelect"
                      placeholder="Type of Visa"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.typeofVisa
                          ? "is-invalid"
                          : ""
                      }`}
                      optionData={visaTypeOptions?.map((opt) => ({
                        value: opt.value.toString(),
                        label: opt.label,
                      }))}
                      onSelect={(selectedOption) => {
                        setValue(
                          `otherVisaDetails[${index}].typeofVisa`,
                          selectedOption
                        );
                      }}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].duration`}
                      type="text"
                      placeholder="Duration"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.duration
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].issuesDate`}
                      type="date"
                      placeholder="Issue Date"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.issuesDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`otherVisaDetails[${index}].issuesDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].expiryDate`}
                      type="date"
                      placeholder="Expiry Date"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.expiryDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`otherVisaDetails[${index}].expiryDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].issuedBy`}
                      type="text"
                      placeholder="Issued By"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.issuedBy
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].sposorship`}
                      type="text"
                      placeholder="Sposorship"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.sposorship
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].busniessVisa`}
                      type="text"
                      placeholder="Busniess Visa"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.busniessVisa
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].country`}
                      type="text"
                      placeholder="Country"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.country
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].agentName`}
                      type="text"
                      placeholder="Agent Name"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.agentName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].agentPhone`}
                      type="text"
                      placeholder="Agent Number"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.agentPhone
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].agentEmail`}
                      type="text"
                      placeholder="Agent Email"
                      className={`form-control ${
                        errors?.otherVisaDetails?.[index]?.agentEmail
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `otherVisaDetails[${index}].frontImage`
                      )}
                      setBase64Value={(value) =>
                        setValue(`otherVisaDetails[${index}].frontImage`, value)
                      }
                    />
                  </td>

                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `otherVisaDetails[${index}].backImage`
                      )}
                      setBase64Value={(value) =>
                        setValue(`otherVisaDetails[${index}].backImage`, value)
                      }
                    />
                  </td>

                  <td>
                    <Input
                      name={`otherVisaDetails[${index}].isActive`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.otherVisaDetails?.[index]?.isActive
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={activestatus}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "otherVisaDetails[${index}].isActive",
                          selectedOption
                        );
                        trigger("otherVisaDetails[${index}].isActive");
                      }}
                      defaultValue={watch(
                        "otherVisaDetails[${index}].isActive"
                      )}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VisaDetails;
